import { useSetRecoilState } from 'recoil'

import { loaderState } from 'recoils/atoms'

type PromiseLoader = <T extends (args?: Parameters<T>) => ReturnType<T>>(
  fn: T,
) => Promise<ReturnType<T>>

export const usePromiseLoader = (): PromiseLoader => {
  const setLoader = useSetRecoilState(loaderState)

  const promiseLoader: PromiseLoader = async (fn) => {
    setLoader(true)
    const result = await fn()
    setLoader(false)

    return result
  }

  return promiseLoader
}

export default usePromiseLoader
